import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'

export type AdminOrganization = {
    _id: string
    name: string
    lightModeImage?: string
    image?: string
    isPicoEnabled?: boolean
    isMaiaEnabled?: boolean
    isAllowedUsersEnabled?: boolean
    isFreeTrial?: boolean
    freeTrialStartDate?: string
    isFavorite?: boolean
    userCount: number
    roadmapCount: number
    adminCount: number
    createdAt: string
}

export type AdminOrganizationsResponse = {
    success: boolean
    data: {
        organizations: AdminOrganization[]
        pagination: {
            page: number
            limit: number
            total: number
            totalPages: number
        }
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminOrganizationsQuery = (page: number = 1, limit: number = 20) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getOrganizations = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.adminGetOrganizations
            const response = await callAPI(`${url}?page=${page}&limit=${limit}`, method, token)
            return response
        } catch (e) {
            console.error('Error fetching admin organizations:', e)
            throw e
        }
    }

    return useQuery<AdminOrganizationsResponse>(['admin', 'organizations', page, limit], getOrganizations, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading,
        cacheTime: FIVE_MINUTES,
        staleTime: 30000,
        retry: 3,
        keepPreviousData: true,
    })
}
